export default __webpack_public_path__ + "static/media/Staad2.3e703409.webp";